import { defineRouting } from "next-intl/routing";

export const routing = defineRouting({
	defaultLocale: "de",
	localePrefix: "as-needed",
	locales: ["de", "en"],
});
